module.exports = __webpack_public_path__ + "static/media/application-5-crop-desktop.d479785b.jpg";